import { render } from "./farm_dailies.vue?vue&type=template&id=640efe67"
import script from "./farm_dailies.vue?vue&type=script&lang=js"
export * from "./farm_dailies.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__